import React, { useState, useEffect } from 'react'
import {
  classnames,
  Button,
  Icon,
  InfoOutlined,
  InfoFilled,
  ChevronDown,
  ChevronUp,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

const STORAGE_KEY = 'promoteModelWarningBannerExpanded'

function PromoteModelWarningBanner() {
  const [bannerExpanded, setBannerExpanded] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY)
      return saved !== null ? JSON.parse(saved) : true
    } catch (error) {
      console.warn('Failed to load banner state from localStorage:', error)
      return true
    }
  })

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(bannerExpanded))
    } catch (error) {
      console.warn('Failed to save banner state to localStorage:', error)
    }
  }, [bannerExpanded])

  return (
    <div className={classnames(
      'cgt-notice-outline',
      'cgt-notice-outline--info',
      'cgt-notice-outline--thick',
      'promote-modal__warning-banner'
    )}
    >
      <div className={classnames(
        'promote-modal__banner-header',
        bannerExpanded && 'promote-modal__banner-header--expanded'
      )}
      >
        <Icon
          svgComponent={bannerExpanded ? InfoFilled : InfoOutlined}
          color={bannerExpanded ? 'light' : 'dark'}
          size="default"
          className="promote-modal__banner-icon"
        />
        <h3 className="promote-modal__banner-title">Boost Your Model's Visibility 🚀</h3>
        <Button
          icon={(
            <Icon
              svgComponent={bannerExpanded ? ChevronUp : ChevronDown}
              color={bannerExpanded ? 'light' : 'dark'}
              className="promote-modal__banner-icon"
            />
          )}
          size="small"
          type="ghost"
          variant="only-icon"
          onClick={() => setBannerExpanded(!bannerExpanded)}
        />
      </div>
      {bannerExpanded && (
        <>
          <div className="promote-modal__banner-content">
            <p className="promote-modal__banner-paragraph">
              Want to boost your model's visibility and attract more buyers? Use <strong>Boost Credits</strong> to
              promote your published models.
            </p>
            <p className="promote-modal__banner-subtitle">How it works:</p>
            <ol className="promote-modal__banner-ordered-list">
              <li className="promote-modal__banner-list-item">
                Choose the tags under which you'd like to promote it.
              </li>
              <ol type="a" className="promote-modal__banner-ordered-list">
                <li className="promote-modal__banner-list-item">
                  Tags with higher popularity bring more traffic - but also cost more to promote.
                </li>
                <li className="promote-modal__banner-list-item">
                  Boost credits are spent based on the tags' popularity and promotion duration.
                </li>
              </ol>
              <li className="promote-modal__banner-list-item">
                Select how many days you want your model to be promoted.
              </li>
              <li className="promote-modal__banner-list-item">
                Your model will appear higher in search results under the selected tags, marked as{' '}
                <i>Sponsored</i>.
              </li>
            </ol>
            <p className="promote-modal__banner-paragraph promote-modal__banner-secondary-subtitle">
              <strong className="promote-modal__banner-subtitle">
                Things to keep in mind:
              </strong>
            </p>
            <ul className="promote-modal__banner-unordered-list">
              <li className="promote-modal__banner-list-item">
                Your model will go through a moderation process before the promotion.
              </li>
              <li className="promote-modal__banner-list-item">
                The earliest your campaign can start is the next day after it's launched and approved.
              </li>
              <li className="promote-modal__banner-list-item">
                Your promotion only counts on days your model is shown.
              </li>
              <li className="promote-modal__banner-list-item">
                We may review and stop any campaigns that violate our{' '}
                <a
                  href="/pages/cgtrader-content-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cgt-legacy-link"
                >
                  Content Policy
                </a>.
              </li>
            </ul>
          </div>
          <div className="promote-modal__banner-actions">
            <Button
              size="small"
              type="secondary"
              onClick={() => setBannerExpanded(false)}
            >
              Okay, got it
            </Button>
          </div>
        </>
      )}
    </div>
  )
}

export default PromoteModelWarningBanner
